var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsicsSpiralLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.5 80.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "asics-a") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.52,57.54c-4.59,0-6.8-3.53-5.65-7.62,2.38-8.47,17.68-21,28.1-21,7.61,0,7,6.8,2.57,12.61l-2.46,2.72c-8.83,8.67-17,13.31-22.56,13.31M62.78.44c-13.3,0-28,8.15-37.15,15.85l.73,1.05C40.63,7.34,60.45.83,65.91,10.59c2.88,5.15-2,15.56-8.91,23.78,1.65-3.63.56-10.6-9.05-10.6C32,23.76.5,44.94.5,66.61.5,75.29,6.52,81,16.44,81,43,81,79,37.43,79,15.57,79,7.85,74.56.44,62.78.44",
    transform: "translate(-0.5 -0.44)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsicsSpiralLogoBlack);
export default __webpack_public_path__ + "static/media/asics-spiral-logo-black.db97f789ec092ce539dbb1e156ba7ec3.svg";
export { ForwardRef as ReactComponent };